// // import React, { useState, useEffect } from 'react';
// // import { motion } from 'framer-motion';
// // import './Donation.css';
// // import { useLanguage } from '../context/LanguageContext';
// // import Toast from '../components/Toast';

// // /* Scroll-reveal hook */
// // const useScrollReveal = (selector, options = {}) => {
// //   useEffect(() => {
// //     const observer = new IntersectionObserver((entries) => {
// //       entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
// //     }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
// //     document.querySelectorAll(selector).forEach(el => observer.observe(el));
// //     return () => observer.disconnect();
// //   }, [selector]);
// // };

// // const Donation = () => {
// //   const { t } = useLanguage();
// //   const [formData, setFormData] = useState({
// //     name: '',
// //     email: '',
// //     phone: '',
// //     amount: '',
// //     purpose: 'general',
// //     customPurpose: '',
// //     message: ''
// //   });
// //   const [loading, setLoading] = useState(false);
// //   const [status, setStatus] = useState({ type: null, text: null });
// //   const [toast, setToast] = useState(null);

// //   const showToast = (message, type = 'error') => {
// //     setToast({ message, type });
// //   };

// //   const formatIndianCurrency = (num) => {
// //     if (!num) return '';
// //     const n = num.toString().replace(/,/g, '');
// //     if (isNaN(n)) return num;
// //     const parts = n.split('.');
// //     let lastThree = parts[0].substring(parts[0].length - 3);
// //     const otherBlocks = parts[0].substring(0, parts[0].length - 3);
// //     if (otherBlocks !== '') {
// //       lastThree = ',' + lastThree;
// //     }
// //     const formatted = otherBlocks.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
// //     return parts.length > 1 ? formatted + '.' + parts[1] : formatted;
// //   };

// //   const validateForm = () => {
// //     const { name, email, phone, amount } = formData;

// //     // Name validation
// //     if (name.trim().length < 3) {
// //       return t('validation.nameError');
// //     }

// //     // Email validation
// //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// //     if (!emailRegex.test(email)) {
// //       return t('validation.emailError');
// //     }

// //     // Phone validation (exactly 10 digits and starts with 6-9)
// //     const phoneDigits = phone.replace(/\D/g, '');
// //     if (phoneDigits.length !== 10) {
// //       return t('validation.phoneError');
// //     }
// //     if (!/^[6-9]/.test(phoneDigits)) {
// //       return t('validation.phoneStartError');
// //     }

// //     // Amount validation
// //     const cleanAmount = amount.toString().replace(/,/g, '');
// //     if (!cleanAmount || parseFloat(cleanAmount) <= 0) {
// //       return t('validation.amountError');
// //     }

// //     return null;
// //   };

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;

// //     // Strict numeric only for phone and amount
// //     if (name === 'phone') {
// //       const numericValue = value.replace(/\D/g, '').substring(0, 10);
// //       setFormData({ ...formData, [name]: numericValue });
// //       return;
// //     }

// //     if (name === 'amount') {
// //       const numericValue = value.replace(/\D/g, '');
// //       setFormData({ ...formData, [name]: formatIndianCurrency(numericValue) });
// //       return;
// //     }

// //     setFormData({ ...formData, [name]: value });
// //   };

// //   const resetForm = () => {
// //     setFormData({
// //       name: '',
// //       email: '',
// //       phone: '',
// //       amount: '',
// //       purpose: 'general',
// //       customPurpose: '',
// //       message: ''
// //     });
// //   };

// //   const loadRazorpayScript = () => {
// //     return new Promise((resolve) => {
// //       const script = document.createElement('script');
// //       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
// //       script.onload = () => resolve(true);
// //       script.onerror = () => resolve(false);
// //       document.body.appendChild(script);
// //     });
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     const validationError = validateForm();
// //     if (validationError) {
// //       showToast(validationError, 'error');
// //       return;
// //     }

// //     setLoading(true);
// //     setStatus({ type: null, text: null });

// //     try {
// //       const res = await fetch('https://mhaskobaadmin.tipic.in/api/donate/initiate', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({
// //           ...formData,
// //           amount: formData.amount.toString().replace(/,/g, ''),
// //           purpose: formData.purpose === 'other' ? formData.customPurpose : formData.purpose
// //         }),
// //       });

// //       const data = await res.json();

// //       if (!data.success) {
// //         throw new Error(data.message || 'ऑर्डर तयार करताना त्रुटी');
// //       }

// //       const scriptLoaded = await loadRazorpayScript();
// //       if (!scriptLoaded) {
// //         throw new Error('Razorpay लोड झाला नाही');
// //       }

// //       const options = {
// //         key: data.key,
// //         amount: data.amount,
// //         currency: 'INR',
// //         name: 'श्री श्रीनाथ म्हस्कोबा महाराज मंदिर',
// //         description: `दान - ${data.purpose}`,
// //         order_id: data.order_id,
// //         prefill: {
// //           name: data.name,
// //           email: data.email,
// //           contact: data.phone,
// //         },
// //         notes: {
// //           purpose: data.purpose,
// //         },
// //         theme: { color: '#F37254' },
// //         handler: async function (response) {

// //           resetForm();
// //           // Payment successful → verify
// //           const verifyRes = await fetch('https://mhaskobaadmin.tipic.in/api/donate/verify', {
// //             method: 'POST',
// //             headers: { 'Content-Type': 'application/json' },
// //             body: JSON.stringify({
// //               razorpay_payment_id: response.razorpay_payment_id,
// //               razorpay_order_id: response.razorpay_order_id,
// //               razorpay_signature: response.razorpay_signature,
// //               amount: data.amount,
// //               name: data.name,
// //               email: data.email,
// //               phone: data.phone,
// //               purpose: data.purpose,
// //               customPurpose: formData.customPurpose,
// //               message: formData.message,

// //             }),
// //           });

// //           const verifyData = await verifyRes.json();

// //           if (verifyData.success) {
// //             showToast(verifyData.message, 'success');
// //             setFormData({ name: '', email: '', phone: '', amount: '', purpose: 'general', customPurpose: '', message: '' });
// //           } else {
// //             showToast('पेमेंट यशस्वी झाले पण सत्यापनात त्रुटी आली.', 'error');
// //           }
// //         },
// //       };

// //       const razorpay = new window.Razorpay(options);
// //       razorpay.open();

// //     } catch (err) {
// //       showToast(err.message || 'काहीतरी चूक झाली. पुन्हा प्रयत्न करा.', 'error');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useScrollReveal('.reveal');

// //   return (
// //     <motion.div 
// //       className="donation-page"
// //       initial={{ opacity: 0, y: 30 }}
// //       animate={{ opacity: 1, y: 0 }}
// //       transition={{ duration: 0.6 }}
// //     >
// //       {toast && (
// //         <Toast
// //           message={toast.message}
// //           type={toast.type}
// //           onClose={() => setToast(null)}
// //         />
// //       )}

// //       {/* ── CINEMATIC HERO ── */}
// //       <div className="donation-hero">
// //         <div className="donation-hero-bg" />
// //         <div className="donation-hero-overlay" />
// //         <div className="donation-hero-rays" aria-hidden="true">
// //           <span className="hero-ray hero-ray-1" />
// //           <span className="hero-ray hero-ray-2" />
// //           <span className="hero-ray hero-ray-3" />
// //           <span className="hero-ray hero-ray-4" />
// //           <span className="hero-ray hero-ray-5" />
// //         </div>
// //         <div className="donation-hero-content">
// //           <span className="page-hero-pill">{t('pageContent.donateNow')}</span>
// //           <h1 className="page-hero-title">{t('donation.pageTitle')}</h1>
// //           <div className="page-hero-divider">
// //             <span className="phd-line" />
// //             <span className="phd-diamond">◆</span>
// //             <span className="phd-line" />
// //           </div>
// //         </div>
// //         <div className="page-hero-bottom-line" />
// //       </div>

// //       <div className="container">
// //         <section className="donation-intro reveal">
// //           <p>
// //             {t('donation.intro')}
// //           </p>
// //         </section>

// //         <div className="donation-content">
// //           <div className="donation-form-section reveal">
// //             <h2>{t('donation.formTitle')}</h2>
// //             <form className="donation-form" onSubmit={handleSubmit}>
// //               <div className="form-group">
// //                 <label>{t('donation.fullName')} *</label>
// //                 <input
// //                   type="text"
// //                   name="name"
// //                   value={formData.name}
// //                   onChange={handleChange}
// //                   required
// //                   placeholder={t('contact.fullNamePlaceholder')}
// //                 />
// //               </div>

// //               <div className="form-group">
// //                 <label>{t('donation.emailAddress')} *</label>
// //                 <input
// //                   type="email"
// //                   name="email"
// //                   value={formData.email}
// //                   onChange={handleChange}
// //                   required
// //                   placeholder={t('contact.emailPlaceholder')}
// //                 />
// //               </div>

// //               <div className="form-group">
// //                 <label>{t('donation.phoneNumber')} *</label>
// //                 <input
// //                   type="tel"
// //                   name="phone"
// //                   value={formData.phone}
// //                   onChange={handleChange}
// //                   required
// //                   placeholder={t('contact.phonePlaceholder')}
// //                 />
// //               </div>

// //               <div className="form-group">
// //                 <label>{t('donation.donationAmount')} *</label>
// //                 <div className="amount-input-wrapper">
// //                   <span className="currency-symbol">₹</span>
// //                   <input
// //                     type="text"
// //                     name="amount"
// //                     value={formData.amount}
// //                     onChange={handleChange}
// //                     required
// //                     placeholder="0"
// //                   />
// //                 </div>
// //               </div>

// //               {/* <div className="form-group">
// //                 <label>{t('donation.donationPurpose')} *</label>
// //                 <select
// //                   name="purpose"
// //                   value={formData.purpose}
// //                   onChange={handleChange}
// //                   required
// //                 >
// //                   <option value="general">{t('donation.donationPurposes.general')}</option>
// //                   <option value="annadan">{t('donation.donationPurposes.annadan')}</option>
// //                   <option value="development">{t('donation.donationPurposes.development')}</option>
// //                   <option value="gaushala">{t('donation.donationPurposes.gaushala')}</option>
// //                   <option value="festival">{t('donation.donationPurposes.festival')}</option>
// //                   <option value="maintenance">{t('donation.donationPurposes.maintenance')}</option>
// //                   <option value="other">{t('donation.donationPurposes.other')}</option>
// //                 </select>
// //               </div> */}

// //               {formData.purpose === 'other' && (
// //                 <div className="form-group animate-in">
// //                   <label>{t('donation.donationPurpose')} (Custom) *</label>
// //                   <input
// //                     type="text"
// //                     name="customPurpose"
// //                     value={formData.customPurpose}
// //                     onChange={handleChange}
// //                     required
// //                     placeholder={t('donation.otherPurposePlaceholder')}
// //                   />
// //                 </div>
// //               )}

// //               {/* <div className="form-group">
// //                 <label>{t('donation.message')}</label>
// //                 <textarea
// //                   name="message"
// //                   value={formData.message}
// //                   onChange={handleChange}
// //                   rows="4"
// //                   placeholder={t('contact.messagePlaceholder')}
// //                 ></textarea>
// //               </div> */}

// //               <button type="submit" className="submit-btn" disabled={loading}>
// //                 {loading ? 'Processing...' : t('donation.proceedToPayment')}
// //               </button>
// //             </form>
// //           </div>

// //           <div className="donation-info-section reveal">
// //             <div className="info-card reveal" style={{ '--stagger-index': 1 }}>
// //               <h3>{t('donation.quickDonationOptions')}</h3>
// //               <div className="quick-amounts">
// //                 <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '500' })}>₹500</button>
// //                 <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '1,000' })}>₹1,000</button>
// //                 <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '2,500' })}>₹2,500</button>
// //                 <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '5,000' })}>₹5,000</button>
// //                 <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '10,000' })}>₹10,000</button>
// //                 <button className="amount-btn custom-btn" onClick={() => {
// //                   setFormData({ ...formData, amount: '' });
// //                   document.getElementsByName('amount')[0]?.focus();
// //                 }}>{t('donation.customAmount')}</button>
// //               </div>
// //             </div>

// //             <div className="info-card reveal" style={{ '--stagger-index': 2 }}>
// //               <h3>{t('donation.upiPayment')}</h3>
// //               <div className="qr-placeholder">
// //                 <span className="qr-icon">📲</span>
// //                 <p>{t('donation.scanQRCode')}</p>
// //               </div>
// //               <p className="upi-id">{t('donation.upiId')}</p>
// //             </div>

// //             <div className="info-card reveal" style={{ '--stagger-index': 3 }}>
// //               <h3>{t('donation.bankDetails')}</h3>
// //               <div className="bank-details">
// //                 <p><strong>{t('donation.accountName')}</strong></p>
// //                 <p><strong>{t('donation.accountNumber')}</strong></p>
// //                 <p><strong>{t('donation.ifscCode')}</strong></p>
// //                 <p><strong>{t('donation.bank')}</strong></p>
// //                 <p><strong>{t('donation.branch')}</strong></p>
// //               </div>
// //             </div>

// //             <div className="info-card tax-benefit reveal" style={{ '--stagger-index': 4 }}>
// //               <h3>{t('donation.taxBenefits')}</h3>
// //               <p>
// //                 {t('donation.taxText')}
// //               </p>
// //             </div>
// //           </div>
// //         </div>

// //         <section className="donation-impact reveal">
// //           <h2 className="section-title">{t('donation.howYourDonationHelps')}</h2>
// //           <div className="header-divider section-divider">
// //             <span className="dot"></span>
// //             <span className="line"></span>
// //             <span className="dot"></span>
// //           </div>

// //           <div className="impact-grid">
// //             <div className="impact-card reveal" style={{ '--stagger-index': 1 }}>
// //               <div className="impact-card-header">
// //                 <div className="impact-icon">🍽️</div>
// //                 <h3>{t('donation.annadan.title')}</h3>
// //               </div>
// //               <p>{t('donation.annadan.description')}</p>
// //             </div>
// //             <div className="impact-card reveal" style={{ '--stagger-index': 2 }}>
// //               <div className="impact-card-header">
// //                 <div className="impact-icon">🏛️</div>
// //                 <h3>{t('donation.templeDevelopment.title')}</h3>
// //               </div>
// //               <p>{t('donation.templeDevelopment.description')}</p>
// //             </div>
// //             <div className="impact-card reveal" style={{ '--stagger-index': 3 }}>
// //               <div className="impact-card-header">
// //                 <div className="impact-icon">🐄</div>
// //                 <h3>{t('donation.gauSeva.title')}</h3>
// //               </div>
// //               <p>{t('donation.gauSeva.description')}</p>
// //             </div>
// //             <div className="impact-card reveal" style={{ '--stagger-index': 4 }}>
// //               <div className="impact-card-header">
// //                 <div className="impact-icon">🎉</div>
// //                 <h3>{t('donation.festivals.title')}</h3>
// //               </div>
// //               <p>{t('donation.festivals.description')}</p>
// //             </div>
// //           </div>
// //         </section>
// //       </div>
// //     </motion.div>
// //   );
// // };

// // export default Donation;










// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import './Donation.css';
// import { useLanguage } from '../context/LanguageContext';
// import Toast from '../components/Toast';

// const useScrollReveal = (selector, options = {}) => {
//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
//     }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
//     document.querySelectorAll(selector).forEach(el => observer.observe(el));
//     return () => observer.disconnect();
//   }, [selector]);
// };

// const Donation = () => {
//   const { t } = useLanguage();
//   const [formData, setFormData] = useState({
//     name: '', email: '', phone: '', amount: '',
//     purpose: 'general', customPurpose: '', message: ''
//   });
//   const [loading, setLoading] = useState(false);
//   const [toast, setToast] = useState(null);

//   const showToast = (message, type = 'error') => setToast({ message, type });

//   const formatIndianCurrency = (num) => {
//     if (!num) return '';
//     const n = num.toString().replace(/,/g, '');
//     if (isNaN(n)) return num;
//     const parts = n.split('.');
//     let lastThree = parts[0].substring(parts[0].length - 3);
//     const otherBlocks = parts[0].substring(0, parts[0].length - 3);
//     if (otherBlocks !== '') lastThree = ',' + lastThree;
//     const formatted = otherBlocks.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
//     return parts.length > 1 ? formatted + '.' + parts[1] : formatted;
//   };

//   const validateForm = () => {
//     const { name, email, phone, amount } = formData;
//     if (name.trim().length < 3) return t('validation.nameError');
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(email)) return t('validation.emailError');
//     const phoneDigits = phone.replace(/\D/g, '');
//     if (phoneDigits.length !== 10) return t('validation.phoneError');
//     if (!/^[6-9]/.test(phoneDigits)) return t('validation.phoneStartError');
//     const cleanAmount = amount.toString().replace(/,/g, '');
//     if (!cleanAmount || parseFloat(cleanAmount) <= 0) return t('validation.amountError');
//     return null;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'phone') { setFormData({ ...formData, [name]: value.replace(/\D/g, '').substring(0, 10) }); return; }
//     if (name === 'amount') { setFormData({ ...formData, [name]: formatIndianCurrency(value.replace(/\D/g, '')) }); return; }
//     setFormData({ ...formData, [name]: value });
//   };

//   const resetForm = () => setFormData({ name: '', email: '', phone: '', amount: '', purpose: 'general', customPurpose: '', message: '' });

//   const loadRazorpayScript = () => new Promise((resolve) => {
//     const script = document.createElement('script');
//     script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//     script.onload = () => resolve(true);
//     script.onerror = () => resolve(false);
//     document.body.appendChild(script);
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationError = validateForm();
//     if (validationError) { showToast(validationError, 'error'); return; }
//     setLoading(true);
//     try {
//       const res = await fetch('https://mhaskobaadmin.tipic.in/api/donate/initiate', {
//         method: 'POST', headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ ...formData, amount: formData.amount.toString().replace(/,/g, ''), purpose: formData.purpose === 'other' ? formData.customPurpose : formData.purpose }),
//       });
//       const data = await res.json();
//       if (!data.success) throw new Error(data.message || 'ऑर्डर तयार करताना त्रुटी');
//       const scriptLoaded = await loadRazorpayScript();
//       if (!scriptLoaded) throw new Error('Razorpay लोड झाला नाही');
//       const options = {
//         key: data.key, amount: data.amount, currency: 'INR',
//         name: 'श्री श्रीनाथ म्हस्कोबा महाराज मंदिर',
//         description: `दान - ${data.purpose}`, order_id: data.order_id,
//         prefill: { name: data.name, email: data.email, contact: data.phone },
//         notes: { purpose: data.purpose }, theme: { color: '#F37254' },
//         handler: async function (response) {
//           resetForm();
//           const verifyRes = await fetch('https://mhaskobaadmin.tipic.in/api/donate/verify', {
//             method: 'POST', headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ razorpay_payment_id: response.razorpay_payment_id, razorpay_order_id: response.razorpay_order_id, razorpay_signature: response.razorpay_signature, amount: data.amount, name: data.name, email: data.email, phone: data.phone, purpose: data.purpose, customPurpose: formData.customPurpose, message: formData.message }),
//           });
//           const verifyData = await verifyRes.json();
//           if (verifyData.success) showToast(verifyData.message, 'success');
//           else showToast('पेमेंट यशस्वी झाले पण सत्यापनात त्रुटी आली.', 'error');
//         },
//       };
//       const razorpay = new window.Razorpay(options);
//       razorpay.open();
//     } catch (err) {
//       showToast(err.message || 'काहीतरी चूक झाली. पुन्हा प्रयत्न करा.', 'error');
//     } finally { setLoading(false); }
//   };

//   useScrollReveal('.impact-scroll-item');
//   useScrollReveal('.donation-intro-scroll');
//   useScrollReveal('.donation-form-card');
//   useScrollReveal('.donation-info-card');

//   return (
//     <motion.div className="donation-page" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
//       {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

//       {/* HERO */}
//       <div className="donation-hero">
//         <div className="donation-hero-bg" />
//         <div className="donation-hero-overlay" />
//         <div className="donation-hero-rays" aria-hidden="true">
//           {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
//         </div>
//         <div className="donation-hero-content">
//           <span className="page-hero-pill">{t('pageContent.donateNow')}</span>
//           <h1 className="page-hero-title">{t('donation.pageTitle')}</h1>
//           <div className="page-hero-divider">
//             <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
//           </div>
//         </div>
//         <div className="page-hero-bottom-line" />
//       </div>

//       <div className="container">

//         {/* Intro scroll */}
//         <section className="donation-intro-section">
//           <div className="donation-intro-scroll">
//             <div className="donation-intro-content">
//               <h2 className="donation-intro-title">{t('donation.pageTitle')}</h2>
//               <div className="parchment-divider" />
//               <p className="donation-intro-text">{t('donation.intro')}</p>
//             </div>
//           </div>
//         </section>

//         {/* Main grid — equal columns, plain cards */}
//      <section className="donation-main-section">
//   <div className="donation-main-grid">

//     {/* Row 1 – Left: Form | Right: Quick Amounts + UPI */}
//     <div className="donation-row">
//       {/* Left – Donation Form */}
//       <div className="donation-form-card">
//         <h2>{t('donation.formTitle')}</h2>
//         <div className="card-divider" />
//         <form className="donation-form" onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label>{t('donation.fullName')} *</label>
//             <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder={t('contact.fullNamePlaceholder')} />
//           </div>
//           <div className="form-group">
//             <label>{t('donation.emailAddress')} *</label>
//             <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder={t('contact.emailPlaceholder')} />
//           </div>
//           <div className="form-group">
//             <label>{t('donation.phoneNumber')} *</label>
//             <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder={t('contact.phonePlaceholder')} />
//           </div>
//           <div className="form-group">
//             <label>{t('donation.donationAmount')} *</label>
//             <div className="amount-input-wrapper">
//               <span className="currency-symbol">₹</span>
//               <input type="text" name="amount" value={formData.amount} onChange={handleChange} required placeholder="0" />
//             </div>
//           </div>
//           {formData.purpose === 'other' && (
//             <div className="form-group">
//               <label>{t('donation.donationPurpose')} *</label>
//               <input type="text" name="customPurpose" value={formData.customPurpose} onChange={handleChange} required placeholder={t('donation.otherPurposePlaceholder')} />
//             </div>
//           )}
//           <button type="submit" className="submit-btn" disabled={loading}>
//             {loading ? 'Processing...' : t('donation.proceedToPayment')}
//           </button>
//         </form>
//       </div>

//       {/* Right – Quick Amounts + UPI QR */}
//       <div className="donation-info-card amount-upi-card">
//         <p className="donation-info-section-title">{t('donation.quickDonationOptions')}</p>
//         <div className="card-divider" />
//         <div className="quick-amounts">
//           {['500','1,000','2,500','5,000','10,000'].map(amt => (
//             <button key={amt} className="amount-btn" onClick={() => setFormData({ ...formData, amount: amt })}>₹{amt}</button>
//           ))}
//           <button className="amount-btn custom-btn" onClick={() => { setFormData({ ...formData, amount: '' }); document.getElementsByName('amount')[0]?.focus(); }}>
//             {t('donation.customAmount')}
//           </button>
//         </div>

//         <p className="donation-info-section-title upi-title">{t('donation.upiPayment')}</p>
//         <div className="card-divider" />
//         <div className="qr-placeholder">
//           <span className="qr-icon">📲</span>
//           <p>{t('donation.scanQRCode')}</p>
//         </div>
//         <p className="upi-id">{t('donation.upiId')}</p>
//       </div>
//     </div>

//     {/* Row 2 – Bank Details | Tax Benefits */}
//     <div className="donation-row">
//       {/* Left – Bank Details */}
//       <div className="donation-info-card bank-card">
//         <p className="donation-info-section-title">{t('donation.bankDetails')}</p>
//         <div className="card-divider" />
//         <div className="bank-details">
//           <p><strong>{t('donation.accountName')}</strong></p>
//           <p><strong>{t('donation.accountNumber')}</strong></p>
//           <p><strong>{t('donation.ifscCode')}</strong></p>
//           <p><strong>{t('donation.bank')}</strong></p>
//           <p><strong>{t('donation.branch')}</strong></p>
//         </div>
//       </div>

//       {/* Right – Tax Benefits */}
//       <div className="donation-info-card tax-card">
//         <p className="donation-info-section-title">{t('donation.taxBenefits')}</p>
//         <div className="card-divider" />
//         <p className="tax-text">{t('donation.taxText')}</p>
//       </div>
//     </div>

//   </div>
// </section>

//         {/* Impact — 4 parchment scrolls */}
//         <section className="donation-impact-section">
//           <h2 className="section-title">{t('donation.howYourDonationHelps')}</h2>
//           <div className="section-header-divider">
//             <span className="dot" /><span className="line" /><span className="dot" />
//           </div>
//           <div className="impact-grid">
//             {[
//               { icon: '🍽️', titleKey: 'donation.annadan.title',           descKey: 'donation.annadan.description' },
//               { icon: '🏛️', titleKey: 'donation.templeDevelopment.title', descKey: 'donation.templeDevelopment.description' },
//               { icon: '🐄', titleKey: 'donation.gauSeva.title',            descKey: 'donation.gauSeva.description' },
//               { icon: '🎉', titleKey: 'donation.festivals.title',          descKey: 'donation.festivals.description' },
//             ].map((item, idx) => (
//               <div className="impact-scroll-item" key={idx}>
//                 <div className="impact-scroll-content">
//                   <div className="impact-icon-wrap">{item.icon}</div>
//                   <h3 className="impact-title">{t(item.titleKey)}</h3>
//                   <div className="parchment-divider" />
//                   <p className="impact-desc">{t(item.descKey)}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//       </div>
//     </motion.div>
//   );
// };

// export default Donation;















// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import './Donation.css';
// import { useLanguage } from '../context/LanguageContext';
// import Toast from '../components/Toast';
// import QR from '../../src/qr.jpeg'

// const useScrollReveal = (selector, options = {}) => {
//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
//     }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
//     document.querySelectorAll(selector).forEach(el => observer.observe(el));
//     return () => observer.disconnect();
//   }, [selector]);
// };

// const Donation = () => {
//   const { t } = useLanguage();
//   const [donationType, setDonationType] = useState('one-time'); // 'one-time' | 'monthly'
//   const [formData, setFormData] = useState({
//     name: '', email: '', phone: '', amount: '',
//     purpose: 'general', customPurpose: '', message: ''
//   });
//   const [loading, setLoading] = useState(false);
//   const [toast, setToast] = useState(null);

//   const showToast = (message, type = 'error') => setToast({ message, type });

//   const formatIndianCurrency = (num) => {
//     if (!num) return '';
//     const n = num.toString().replace(/,/g, '');
//     if (isNaN(n)) return num;
//     const parts = n.split('.');
//     let lastThree = parts[0].substring(parts[0].length - 3);
//     const otherBlocks = parts[0].substring(0, parts[0].length - 3);
//     if (otherBlocks !== '') lastThree = ',' + lastThree;
//     const formatted = otherBlocks.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
//     return parts.length > 1 ? formatted + '.' + parts[1] : formatted;
//   };

//   const validateForm = () => {
//     const { name, email, phone, amount } = formData;
//     if (name.trim().length < 3) return t('validation.nameError');
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(email)) return t('validation.emailError');
//     const phoneDigits = phone.replace(/\D/g, '');
//     if (phoneDigits.length !== 10) return t('validation.phoneError');
//     if (!/^[6-9]/.test(phoneDigits)) return t('validation.phoneStartError');
//     const cleanAmount = amount.toString().replace(/,/g, '');
//     if (!cleanAmount || parseFloat(cleanAmount) <= 0) return t('validation.amountError');
//     return null;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'phone') {
//       setFormData({ ...formData, [name]: value.replace(/\D/g, '').substring(0, 10) });
//       return;
//     }
//     if (name === 'amount') {
//       setFormData({ ...formData, [name]: formatIndianCurrency(value.replace(/\D/g, '')) });
//       return;
//     }
//     setFormData({ ...formData, [name]: value });
//   };

//   const resetForm = () => setFormData({
//     name: '', email: '', phone: '', amount: '',
//     purpose: 'general', customPurpose: '', message: ''
//   });

//   const loadRazorpayScript = () => new Promise((resolve) => {
//     const script = document.createElement('script');
//     script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//     script.onload = () => resolve(true);
//     script.onerror = () => resolve(false);
//     document.body.appendChild(script);
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationError = validateForm();
//     if (validationError) { showToast(validationError, 'error'); return; }
//     setLoading(true);
//     try {
//       const res = await fetch('https://mhaskobaadmin.tipic.in/api/donate/initiate', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           ...formData,
//           donationType,
//           amount: formData.amount.toString().replace(/,/g, ''),
//           purpose: formData.purpose === 'other' ? formData.customPurpose : formData.purpose
//         }),
//       });
//       const data = await res.json();
//       if (!data.success) throw new Error(data.message || 'ऑर्डर तयार करताना त्रुटी');
//       const scriptLoaded = await loadRazorpayScript();
//       if (!scriptLoaded) throw new Error('Razorpay लोड झाला नाही');
//       const options = {
//         key: data.key, amount: data.amount, currency: 'INR',
//         name: 'श्री श्रीनाथ म्हस्कोबा महाराज मंदिर',
//         description: `दान - ${data.purpose}`, order_id: data.order_id,
//         prefill: { name: data.name, email: data.email, contact: data.phone },
//         notes: { purpose: data.purpose }, theme: { color: '#F37254' },
//         handler: async function (response) {
//           resetForm();
//           const verifyRes = await fetch('https://mhaskobaadmin.tipic.in/api/donate/verify', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_signature: response.razorpay_signature,
//               amount: data.amount, name: data.name, email: data.email,
//               phone: data.phone, purpose: data.purpose,
//               customPurpose: formData.customPurpose, message: formData.message
//             }),
//           });
//           const verifyData = await verifyRes.json();
//           if (verifyData.success) showToast(verifyData.message, 'success');
//           else showToast('पेमेंट यशस्वी झाले पण सत्यापनात त्रुटी आली.', 'error');
//         },
//       };
//       const razorpay = new window.Razorpay(options);
//       razorpay.open();
//     } catch (err) {
//       showToast(err.message || 'काहीतरी चूक झाली. पुन्हा प्रयत्न करा.', 'error');
//     } finally { setLoading(false); }
//   };

//   useScrollReveal('.impact-scroll-item');
//   useScrollReveal('.donation-intro-scroll');
//   useScrollReveal('.donation-form-card');
//   useScrollReveal('.donation-info-card');

//   const oneTimeAmounts = ['500', '1,000', '2,500', '5,000'];
//   const monthlyAmounts = ['100', '500', '1,000', '2,500'];

//   return (
//     <motion.div
//       className="donation-page"
//       initial={{ opacity: 0, y: 30 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.6 }}
//     >
//       {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

//       {/* HERO */}
//       <div className="donation-hero">
//         <div className="donation-hero-bg" />
//         <div className="donation-hero-overlay" />
//         <div className="donation-hero-rays" aria-hidden="true">
//           {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
//         </div>
//         <div className="donation-hero-content">
//           <span className="page-hero-pill">{t('pageContent.donateNow')}</span>
//           <h1 className="page-hero-title">{t('donation.pageTitle')}</h1>
//           <div className="page-hero-divider">
//             <span className="phd-line" />
//             <span className="phd-diamond">◆</span>
//             <span className="phd-line" />
//           </div>
//         </div>
//         <div className="page-hero-bottom-line" />
//       </div>

//       <div className="container">

//         {/* Intro scroll */}
//         <section style={{  "margin-top": "20px",
//   "margin-bottom": "30px"}} 
//   className="donation-intro-section">
//           <div className="donation-intro-scroll">
//             <div className="donation-intro-content">
//               <h2 className="donation-intro-title">{t('donation.pageTitle')}</h2>
//               <div className="parchment-divider" />
//               <p className="donation-intro-text">{t('donation.intro')}</p>
//             </div>
//           </div>
//         </section>

//         {/* Main Section */}
//         <section className="donation-main-section">
//           <div className="donation-main-grid">
//             <div className="donation-row">

//               {/* LEFT — Donation Form */}
//               <div className="donation-form-card">

//                 <h2 className="card-title">{t('donation.formTitle')}</h2>
//                 <div className="card-divider" />

//                 {/* One-Time / Monthly Toggle */}
//                 <div className="donation-type-toggle">
//                   <button
//                     type="button"
//                     className={`toggle-btn ${donationType === 'one-time' ? 'active' : ''}`}
//                     onClick={() => {
//                       setDonationType('one-time');
//                       setFormData({ ...formData, amount: '' });
//                     }}
//                   >
//                     {t('donation.oneTime') || 'One-Time'}
//                   </button>
//                   <button
//                     type="button"
//                     className={`toggle-btn ${donationType === 'monthly' ? 'active' : ''}`}
//                     onClick={() => {
//                       setDonationType('monthly');
//                       setFormData({ ...formData, amount: '' });
//                     }}
//                   >
//                     {t('donation.monthly') || 'Monthly'}
//                   </button>
//                 </div>

//                 <form className="donation-form" onSubmit={handleSubmit}>

//                   {/* Name */}
//                   <div className="form-group">
//                     <input
//                       type="text" name="name"
//                       value={formData.name} onChange={handleChange}
//                       required placeholder={t('contact.fullNamePlaceholder')}
//                     />
//                   </div>

//                   {/* Email */}
//                   <div className="form-group">
//                     <input
//                       type="email" name="email"
//                       value={formData.email} onChange={handleChange}
//                       required placeholder={t('contact.emailPlaceholder')}
//                     />
//                   </div>

//                   {/* Phone */}
//                   <div className="form-group">
//                     <input
//                       type="tel" name="phone"
//                       value={formData.phone} onChange={handleChange}
//                       required placeholder={t('contact.phonePlaceholder')}
//                     />
//                   </div>

//                   {/* Choose Amount */}
//                   <p className="choose-amount-label">{t('donation.quickDonationOptions')}</p>
//                   <div className="quick-amounts">
//                     {(donationType === 'one-time' ? oneTimeAmounts : monthlyAmounts).map(amt => (
//                       <button
//                         key={amt} type="button"
//                         className={`amount-btn ${formData.amount === amt ? 'active' : ''}`}
//                         onClick={() => setFormData({ ...formData, amount: amt })}
//                       >
//                         ₹{amt}
//                       </button>
//                     ))}
//                   </div>

//                   {/* Custom amount */}
//                   <div className="form-group amount-input-wrapper">
//                     <span className="currency-symbol">₹</span>
//                     <input
//                       type="text" name="amount"
//                       value={formData.amount} onChange={handleChange}
//                       required placeholder={t('donation.customAmount') || 'Other Amount'}
//                     />
//                   </div>

//                   {formData.purpose === 'other' && (
//                     <div className="form-group">
//                       <input
//                         type="text" name="customPurpose"
//                         value={formData.customPurpose} onChange={handleChange}
//                         required placeholder={t('donation.otherPurposePlaceholder')}
//                       />
//                     </div>
//                   )}

//                   <button type="submit" className="submit-btn" disabled={loading}>
//                     {loading ? 'Processing...' : t('donation.proceedToPayment')}
//                   </button>

//                 </form>
//               </div>

//               {/* RIGHT — UPI + Bank + Tax */}
//               <div className="donation-right-col">

//                 {/* UPI QR Card */}
//                 <div className="donation-info-card upi-card">
//                   <p className="donation-info-section-title">{t('donation.upiPayment')}</p>
//                   <div className="card-divider" />
//                   <div className="qr-image-wrap">
//                     <img
//                       src={QR}
//                       alt="UPI QR Code"
//                       className="qr-image"
//                       onError={(e) => {
//                         e.target.style.display = 'none';
//                         e.target.nextSibling.style.display = 'flex';
//                       }}
//                     />
//                     <div className="qr-placeholder" style={{ display: 'none' }}>
//                       <span className="qr-icon">📲</span>
//                       <p>{t('donation.scanQRCode')}</p>
//                     </div>
//                   </div>
//                   <p className="upi-id">{t('donation.upiId')}</p>
//                   <p className="upi-scan-label">{t('donation.scanQRCode')}</p>
//                 </div>

//                 {/* Bank Details Card */}
//                 <div className="donation-info-card bank-card">
//                   <p className="donation-info-section-title">{t('donation.bankDetails')}</p>
//                   <div className="card-divider" />
//                   <div className="bank-details">
//                     <p><strong>{t('donation.accountName')}</strong></p>
//                     <p><strong>{t('donation.accountNumber')}</strong></p>
//                     <p><strong>{t('donation.ifscCode')}</strong></p>
//                     <p><strong>{t('donation.bank')}</strong></p>
//                     <p><strong>{t('donation.branch')}</strong></p>
//                   </div>
//                 </div>

//                 {/* Tax Card */}
//                 {/* <div className="donation-info-card tax-card">
//                   <p className="donation-info-section-title">{t('donation.taxBenefits')}</p>
//                   <div className="card-divider" />
//                   <p className="tax-text">{t('donation.taxText')}</p>
//                 </div> */}

//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Impact Section */}
//         <section className="donation-impact-section">
//           <h2 className="section-title">{t('donation.howYourDonationHelps')}</h2>
//           <div className="section-header-divider">
//             <span className="dot" /><span className="line" /><span className="dot" />
//           </div>
//           <div className="impact-grid">
//             {[
//               { icon: '🍽️', titleKey: 'donation.annadan.title',           descKey: 'donation.annadan.description' },
//               { icon: '🏛️', titleKey: 'donation.templeDevelopment.title', descKey: 'donation.templeDevelopment.description' },
//               { icon: '🐄', titleKey: 'donation.gauSeva.title',            descKey: 'donation.gauSeva.description' },
//               { icon: '🎉', titleKey: 'donation.festivals.title',          descKey: 'donation.festivals.description' },
//             ].map((item, idx) => (
//               <div className="impact-scroll-item" key={idx}>
//                 <div className="impact-scroll-content">
//                   <div className="impact-icon-wrap">{item.icon}</div>
//                   <h3 className="impact-title">{t(item.titleKey)}</h3>
//                   <div className="parchment-divider" />
//                   <p className="impact-desc">{t(item.descKey)}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//       </div>
//     </motion.div>
//   );
// };

// export default Donation;








import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Donation.css';
import { useLanguage } from '../context/LanguageContext';
import Toast from '../components/Toast';
import QR from '../../src/qr.jpeg';

const useScrollReveal = (selector, options = {}) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
    document.querySelectorAll(selector).forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

const Donation = () => {
  const { t } = useLanguage();
  const [donationType, setDonationType] = useState('one-time');
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', amount: '',
    purpose: 'general', customPurpose: '', message: ''
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const showToast = (message, type = 'error') => setToast({ message, type });

  const formatIndianCurrency = (num) => {
    if (!num) return '';
    const n = num.toString().replace(/,/g, '');
    if (isNaN(n)) return num;
    const parts = n.split('.');
    let lastThree = parts[0].substring(parts[0].length - 3);
    const otherBlocks = parts[0].substring(0, parts[0].length - 3);
    if (otherBlocks !== '') lastThree = ',' + lastThree;
    const formatted = otherBlocks.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    return parts.length > 1 ? formatted + '.' + parts[1] : formatted;
  };

  const validateForm = () => {
    const { name, email, phone, amount } = formData;
    if (name.trim().length < 3) return t('validation.nameError');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return t('validation.emailError');
    const phoneDigits = phone.replace(/\D/g, '');
    if (phoneDigits.length !== 10) return t('validation.phoneError');
    if (!/^[6-9]/.test(phoneDigits)) return t('validation.phoneStartError');
    const cleanAmount = amount.toString().replace(/,/g, '');
    if (!cleanAmount || parseFloat(cleanAmount) <= 0) return t('validation.amountError');
    return null;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      setFormData({ ...formData, [name]: value.replace(/\D/g, '').substring(0, 10) });
      return;
    }
    if (name === 'amount') {
      setFormData({ ...formData, [name]: formatIndianCurrency(value.replace(/\D/g, '')) });
      return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const resetForm = () => setFormData({
    name: '', email: '', phone: '', amount: '',
    purpose: 'general', customPurpose: '', message: ''
  });

  const loadRazorpayScript = () => new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) { 
      showToast(validationError, 'error'); 
      return; 
    }

    setLoading(true);

    try {
      const res = await fetch('https://mhaskobaadmin.tipic.in/api/donate/initiate', {                    // https://mhaskobaadmin.tipic.in
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          donationType,
          amount: formData.amount.toString().replace(/,/g, ''),
          purpose: formData.purpose === 'other' ? formData.customPurpose : formData.purpose
        }),
      });

      const data = await res.json();
      if (!data.success) throw new Error(data.message || 'ऑर्डर तयार करताना त्रुटी');

      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) throw new Error('Razorpay लोड झाला नाही');

      const options = {
        key: data.key,
        amount: data.amount,
        currency: 'INR',
        name: 'श्री श्रीनाथ म्हस्कोबा महाराज मंदिर',
        description: `दान - ${data.purpose}`,
        order_id: data.order_id,
        prefill: { 
          name: data.name, 
          email: data.email, 
          contact: data.phone 
        },
        notes: { purpose: data.purpose },
        theme: { color: '#F37254' },

        handler: async function (response) {
          // Save important data before reset
          const donorName = data.name;
          const donorEmail = data.email;
          const donorPhone = data.phone;
          const donorAmount = parseFloat(formData.amount.toString().replace(/,/g, ''));

          resetForm();

          try {
            const verifyRes = await fetch('https://mhaskobaadmin.tipic.in/api/donate/verify', {                 //https://mhaskobaadmin.tipic.in
              method: 'POST',
              headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/pdf' 
              },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                name: donorName,
                email: donorEmail,
                phone: donorPhone,
                amount: donorAmount,
                purpose: data.purpose,
                message: formData.message
              }),
            });

            if (!verifyRes.ok) {
              throw new Error('Payment verification failed');
            }

            const contentType = verifyRes.headers.get('content-type') || '';

            if (contentType.includes('pdf') || contentType.includes('application/octet-stream')) {
              const blob = await verifyRes.blob();
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `Donation_Receipt_${response.razorpay_payment_id}.pdf`;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);

              showToast('दान यशस्वी! रसीद डाउनलोड झाली आहे.', 'success');
            } else {
              const verifyData = await verifyRes.json();
              showToast(verifyData.message || 'दान यशस्वी झाले!', 'success');
            }
          } catch (err) {
            console.error('PDF Download Error:', err);
            showToast('पेमेंट यशस्वी झाले, पण रसीद डाउनलोड होऊ शकली नाही.', 'error');
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (err) {
      showToast(err.message || 'काहीतरी चूक झाली. पुन्हा प्रयत्न करा.', 'error');
    } finally {
      setLoading(false);
    }
  };

  useScrollReveal('.impact-scroll-item');
  useScrollReveal('.donation-intro-scroll');
  useScrollReveal('.donation-form-card');
  useScrollReveal('.donation-info-card');

  const oneTimeAmounts = ['500', '1,000', '2,500', '5,000'];
  const monthlyAmounts = ['100', '500', '1,000', '2,500'];

  return (
    <motion.div
      className="donation-page"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      {/* HERO Section */}
      <div className="donation-hero">
        <div className="donation-hero-bg" />
        <div className="donation-hero-overlay" />
        <div className="donation-hero-rays" aria-hidden="true">
          {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
        </div>
        <div className="donation-hero-content">
          <span className="page-hero-pill">{t('pageContent.donateNow')}</span>
          <h1 className="page-hero-title">{t('donation.pageTitle')}</h1>
          <div className="page-hero-divider">
            <span className="phd-line" />
            <span className="phd-diamond">◆</span>
            <span className="phd-line" />
          </div>
        </div>
        <div className="page-hero-bottom-line" />
      </div>

      <div className="container">
        {/* Intro Section */}
        <section style={{ marginTop: "20px", marginBottom: "30px" }} className="donation-intro-section">
          <div className="donation-intro-scroll">
            <div className="donation-intro-content">
              <h2 className="donation-intro-title">{t('donation.pageTitle')}</h2>
              <div className="parchment-divider" />
              <p className="donation-intro-text">{t('donation.intro')}</p>
            </div>
          </div>
        </section>

        {/* Main Section */}
        <section className="donation-main-section">
          <div className="donation-main-grid">
            <div className="donation-row">

              {/* LEFT - Form */}
              <div className="donation-form-card">
                <h2 className="card-title">{t('donation.formTitle')}</h2>
                <div className="card-divider" />

                <div className="donation-type-toggle">
                  <button type="button" className={`toggle-btn ${donationType === 'one-time' ? 'active' : ''}`}
                    onClick={() => { setDonationType('one-time'); setFormData({ ...formData, amount: '' }); }}>
                    {t('donation.oneTime') || 'One-Time'}
                  </button>
                  <button type="button" className={`toggle-btn ${donationType === 'monthly' ? 'active' : ''}`}
                    onClick={() => { setDonationType('monthly'); setFormData({ ...formData, amount: '' }); }}>
                    {t('donation.monthly') || 'Monthly'}
                  </button>
                </div>

                <form className="donation-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input type="text" name="name" value={formData.name} onChange={handleChange}
                      required placeholder={t('contact.fullNamePlaceholder')} />
                  </div>

 <div className="form-group">
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange}
                      required placeholder={t('contact.phonePlaceholder')} />
                  </div>


                  <div className="form-group">
                    <input type="email" name="email" value={formData.email} onChange={handleChange}
                      required placeholder={t('contact.emailPlaceholder')} />
                  </div>

                 

                  <p className="choose-amount-label">{t('donation.quickDonationOptions')}</p>
                  <div className="quick-amounts">
                    {(donationType === 'one-time' ? oneTimeAmounts : monthlyAmounts).map(amt => (
                      <button key={amt} type="button"
                        className={`amount-btn ${formData.amount === amt ? 'active' : ''}`}
                        onClick={() => setFormData({ ...formData, amount: amt })}>
                        ₹{amt}
                      </button>
                    ))}
                  </div>

                  <div className="form-group amount-input-wrapper">
                    <span className="currency-symbol">₹</span>
                    <input type="text" name="amount" value={formData.amount} onChange={handleChange}
                      required placeholder={t('donation.customAmount') || 'Other Amount'} />
                  </div>

                  {formData.purpose === 'other' && (
                    <div className="form-group">
                      <input type="text" name="customPurpose" value={formData.customPurpose}
                        onChange={handleChange} required placeholder={t('donation.otherPurposePlaceholder')} />
                    </div>
                  )}

                  <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Processing...' : t('donation.proceedToPayment')}
                  </button>
                </form>
              </div>

              {/* RIGHT - UPI & Bank */}
              <div className="donation-right-col">
                <div className="donation-info-card upi-card">
                  <p className="donation-info-section-title">{t('donation.upiPayment')}</p>
                  <div className="card-divider" />
                  <div className="qr-image-wrap">
                    <img src={QR} alt="UPI QR Code" className="qr-image" />
                  </div>
                  <p className="upi-id">{t('donation.upiId')}</p>
                  <p className="upi-scan-label">{t('donation.scanQRCode')}</p>
                </div>

                <div className="donation-info-card bank-card">
                  <p className="donation-info-section-title">{t('donation.bankDetails')}</p>
                  <div className="card-divider" />
                  <div className="bank-details">
                    <p><strong>{t('donation.accountName')}</strong></p>
                    <p><strong>{t('donation.accountNumber')}</strong></p>
                    <p><strong>{t('donation.ifscCode')}</strong></p>
                    <p><strong>{t('donation.bank')}</strong></p>
                    <p><strong>{t('donation.branch')}</strong></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Impact Section */}
        <section className="donation-impact-section">
          <h2 className="section-title">{t('donation.howYourDonationHelps')}</h2>
          <div className="section-header-divider">
            <span className="dot" /><span className="line" /><span className="dot" />
          </div>
          <div className="impact-grid">
            {[
              { icon: '🍽️', titleKey: 'donation.annadan.title', descKey: 'donation.annadan.description' },
              { icon: '🏛️', titleKey: 'donation.templeDevelopment.title', descKey: 'donation.templeDevelopment.description' },
              { icon: '🐄', titleKey: 'donation.gauSeva.title', descKey: 'donation.gauSeva.description' },
              { icon: '🎉', titleKey: 'donation.festivals.title', descKey: 'donation.festivals.description' },
            ].map((item, idx) => (
              <div className="impact-scroll-item" key={idx}>
                <div className="impact-scroll-content">
                  <div className="impact-icon-wrap">{item.icon}</div>
                  <h3 className="impact-title">{t(item.titleKey)}</h3>
                  <div className="parchment-divider" />
                  <p className="impact-desc">{t(item.descKey)}</p>
                </div>
              </div>
            ))}
          </div>  
        </section>
      </div>
    </motion.div>
  );
};

export default Donation;